import { render, staticRenderFns } from "./TemplatePosPopUp.vue?vue&type=template&id=23c5ec2a&scoped=true"
import script from "./TemplatePosPopUp.ts?vue&type=script&lang=js&external"
export * from "./TemplatePosPopUp.ts?vue&type=script&lang=js&external"
import style0 from "./TemplatePosPopUp.vue?vue&type=style&index=0&id=23c5ec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5ec2a",
  null
  
)

export default component.exports